// extracted by mini-css-extract-plugin
module.exports = {"tooltipBase":"tooltip_tooltipBase__B16lA","tooltipMessage":"tooltip_tooltipMessage__83_lk","tooltipClose":"tooltip_tooltipClose__xMas6"};